import axios from 'axios'

export const getMyLocation = async (): Promise<{
  coordinate: google.maps.LatLngLiteral | undefined
  region: string | undefined
}> => {
  try {
    const { data } = await axios.get('https://ipapi.co/json/')
    const { latitude, longitude, city, country_name: countryName } = data
    return {
      coordinate: {
        lat: latitude,
        lng: longitude,
      },
      region: `${city}, ${countryName}`,
    }
  } catch (e) {
    return { coordinate: undefined, region: undefined }
  }
}
